<template>
    <div sm12>
        <v-layout  column >
            
            <div class="traffic-title">
                {{type}}
            </div>
            <div class="traffic-description">
                {{jamLength}}&nbsp;
                <span style="text-transform: lowercase;" v-if="jamLength"> {{typeDetails}}</span>
                <span v-else>{{typeDetails}}</span>
            </div>
            <v-flex class="traffic-info-container pt-3">
                <v-flex v-if="publicComment" class="traffic-info ">
                    <div>
                        <i class="traffic-info-icon fa fa-info mr-2" :style="`background-color: ${infoColor};`"></i>
                    </div>
                    <div class="tmp">
                        {{publicComment}}
                    </div>
                </v-flex>
                <v-flex v-if="cause" class="traffic-info ">
                    <div>
                        <i class="traffic-info-icon fa fa-info mr-2" :style="`background-color: ${infoColor};`"></i>
                    </div>
                    <div>
                        {{cause}}
                    </div>
                </v-flex>
            </v-flex>
            <div class="traffic-bottom-container" v-if="locationType=='line'">
                <div class="hecto-container">
                    <div class="hecto-title">
                        <div>{{locationFrom}}</div>                        
                    </div>
                    <div class="hecto-content">
                        <div :class="`${roadNumberClass(roadNumberTo)}`"><div>{{roadNumberTo}}</div></div>                    
                        <div class="traffic-sign hecto"><div>{{hectoFrom}}</div></div>                                            
                    </div>
                </div>
                <div class="bottom-spacer-container">
                    <i class="fas fa-arrow-right fa-3x"></i>
                </div>
                <div class="hecto-container">
                    <div class="hecto-title">
                        <div>{{locationTo}}</div>                        
                    </div>
                    <div class="hecto-content">
                        <div :class="`${roadNumberClass(roadNumberTo)}`"><div>{{roadNumberTo}}</div></div>                    
                        <div class="traffic-sign hecto"><div>{{hectoTo}}</div></div>                                          
                    </div>
                </div>
            </div>
            <div class="traffic-bottom-container" v-else-if="locationType=='point'">
                <div class="hecto-container" style="width: 100%; justify-content:center !important;">
                    
                    <div class="hecto-content">
                        <div class="mr-1 hecto-title">
                        <div>{{locationPoint}}</div>
                        
                        </div>
                        <div class="mx-1" :class="`${roadNumberClass(roadNumberPoint)}`"><div>{{roadNumberPoint}}</div></div>                    
                        <div class="ml-1 traffic-sign hecto"><div>{{hectoPoint}}</div></div>                                            
                    </div>
                </div>
                
            </div>
            <!-- <div class="label">Van</div>
            <div class="value">                                
                <v-layout row wrap justify-space-between align-center>
                    <v-flex>{{locationFrom}}</v-flex>                
                    <div :class="`${roadNumberClass(roadNumberTo)}`"><div>{{roadNumberTo}}</div></div>                    
                    <div class="traffic-sign hecto"><div>{{hectoFrom}}</div></div>                                            
                </v-layout>
            </div>
            <div class="label">Tot</div>
            <div class="value">                
                <v-layout row wrap justify-space-between align-center >                    
                    <v-flex>{{locationTo}}</v-flex>                                        
                    <div :class="`${roadNumberClass(roadNumberTo)}`"><div>{{roadNumberTo}}</div></div>                    
                    <div class="traffic-sign hecto"><div>{{hectoTo}}</div></div>                                                                                 
                </v-layout>
            </div>             -->
        </v-layout>
    </div>
</template>

<script>
    import ColorMixin from '../../plugins/mixins/ColorMixin.js'
    export default {
        mixins: [ColorMixin],
        props: {
            traffic: {
                type: Object
            },
        },
        methods:{
            getLocationPointData(){
                if(this.traffic.location.point && this.traffic.location.point.vild){
                    return this.traffic.location.point.vild.data
                }
                return false;
            },
            getLocationFromData(){
                if(this.traffic.location.from && this.traffic.location.from.vild){
                    return this.traffic.location.from.vild.data
                }
                return false;
            },
            getLocationToData(){
                if(this.traffic.location.to && this.traffic.location.to.vild){
                    return this.traffic.location.to.vild.data
                }
                return false;
            },
            roadNumberClass(road){
                if(!road)
                    return "hideRoad"
                else if(road.charAt(0) == "A")
                    return "traffic-sign high-way"
                else if(road.charAt(0) == "N")
                    return "traffic-sign provincial-road"                                              
            },            
        },
        computed: {
            type() {              
                return (this.traffic.typeTextual)
            },
            locationType() {              
                return (this.traffic.location && this.traffic.location.type == "linear") ? "line" : "point"
            },
            typeDetails(){
                return (this.traffic.typeDetailsTextual && this.traffic.typeDetailsTextual != "Onbekend") ? this.traffic.typeDetailsTextual : ""
            },
            jamLength(){
                if(this.traffic.data && this.traffic.data.queue){
                    return (this.traffic.data.queue/1000)+" km " 
                }
                
                return ""
            },
            publicComment(){
                if(this.traffic.data.publicComment){
                    return this.traffic.data.publicComment
                }
            },
            cause(){
                if(this.traffic.data.caseDescription){
                    return `${this.traffic.data.caseDescription}`
                }
            },
            locationPoint(){                
                return this.getLocationPointData() ? this.getLocationPointData().primaryName : false
            },
            hectoPoint(){
                return this.traffic.location ? (this.traffic.location.hecto/10).toFixed(1) : false
            },
            roadNumberPoint(){
                return this.getLocationPointData() ? this.getLocationPointData().roadNumber : false                    
            },
            locationFrom(){                
                return this.getLocationFromData() ? this.getLocationFromData().primaryName : false
            },
            locationTo(){
                return this.getLocationToData() ? this.getLocationToData().primaryName : false
            },            
            hectoFrom(){
                return this.traffic.location ? (this.traffic.location.hecto.from/10).toFixed(1) : false
            },            
            hectoTo(){
                return this.traffic.location ? (this.traffic.location.hecto.to/10).toFixed(1) : false
            },
            roadNumberFrom(){
                return this.getLocationFromData() ? this.getLocationFromData().roadNumber : false                    
            },
            roadNumberTo(){
                return this.getLocationToData() ? this.getLocationToData().roadNumber : false
            }
        },
        mounted(){

        }
    }
</script>

<style scoped>
    .label{
        font-weight:bold;
    }
    .value{
        display:flex;
        margin-left:4px;
    }
    .hideRoad{
        display:none;
    }
    .traffic-sign{
        font-size: 12px;
        padding:2px;
        text-align:center;
        display:block;        
          
        width:44px;          
        border-radius: 4px;
    }

    .hecto{
        background-color: #006E37;
        color:#FFFFFF;
    }

    .high-way{
        background-color:#f44336;
        color:#FFFFFF;
    }

    .traffic-sign div{
      padding:2px;      
      border:2px solid #ffffff;
    }

    .provincial-road{
       background-color:#F4DD0D;
       color:black;
       padding:0px;
       border:2px solid black;

    }

    .traffic-title{
        display: flex;
        width: 100%;
        font-size: 12px;
        justify-content: center;
        background-color: #ddd;
        padding: 2px;
        font-weight: 600;
    }

    .traffic-description{
        display: flex;
        justify-content: center;
        padding: 10px 2px;
        font-size: 11px;
        background-color: #eee;
    }

    .traffic-info-container{
        display: block !important;
        justify-content: center;
        padding: 10px 2px;
        font-size: 12px;
        background-color: #fff;
        flex-direction: column;        
        
        
        
    }

    .tmp{
        display: block;
            
        overflow-wrap: break-word !important;

        white-space: nowrap;
        
        /* overflow:hidden; */
    }
    .traffic-info{
        display: flex;
        justify-content: center;
        
    }

    .traffic-info div{
        display: flex;        
        word-wrap: break-word;
        


        
    }

    .traffic-info-icon{
        width: 18px !important;
        height: 18px !important;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-size: 10px;
        flex-direction:row;
    }

    

    .traffic-bottom-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

   

    .hecto-container{
        display: flex;
        flex-direction: column;
        justify-content: center;

    }

    .hecto-title{
        
        text-align: center;
        font-weight: 600;
        background-color: #0194e0;
        padding: 2px 2px; 
        color: #fff;
        border-radius: 4px;
        
        
    }

    .hecto-title div {
        padding:2px;      
        border:2px solid #ffffff;
        
    }

    .hecto-content{
        padding: 5px 0px;
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    .bottom-spacer-container{
        color: #bbb;
        display: flex;
        justify-content: center;
        align-items: center;        
    }

    

</style>